import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfService } from 'src/conf.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiConfig } from 'src/app/config/apiConfig';

@Injectable({
  providedIn: 'root'
})
export class LabRequestService {

  private rootUrl: string;
  private labRequestAPIUrl;
  public selectedFacility = new BehaviorSubject<any>('');
  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.labRequestAPIUrl = ApiConfig.LabRequestApiConfig;

  }
  getLabRequests(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLabRequests}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabrotoryData(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLaborataryMasterData}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getProviderData(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getProviderMasterData}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  public fromHelpSubject = new BehaviorSubject<boolean>(false);

  pushValueFromHelp(data) {
    //passing the data as the next observable
    this.fromHelpSubject.next(data);
  }
  getLabTestData(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLabTestMasterData}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabDropDownBox(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLabDropDownBox}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabProfile(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLabProfileMasterData}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  upsertLabRequest(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.upsertLabRequest}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabRequestDetails(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLabRequestDetails}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getFacilityEquipmentsForLab(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getFacilityEquipmentsForLab}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  getLabRequestHistory(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLabRequestHistory}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }


  event: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  emitEvent(data) {
    this.event.next(data);
  }
  disContinueLabRequest(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.disContinueLabRequest}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabFrequency(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labRequestAPIUrl.getLabFrequency}`,ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
}
